import {Box, LoadingOverlay} from "@mantine/core";
import {Navigate, Outlet} from "@tanstack/react-router";
import {useAuth} from "@/app/auth";
import {SyncProvider} from "@/app/storage";

export function AuthGuard() {
  const [{isLoading, session}] = useAuth();

  if (isLoading) {
    return (
      <Box h="100vh" w="100vw">
        <LoadingOverlay visible />
      </Box>
    );
  }

  if (!session) {
    return <Navigate to="/" />;
  }

  return (
    <SyncProvider>
      <Outlet />
    </SyncProvider>
  );
}
